<template>
  <app-logo />
  <theme-toggle />
  <div class="sticky-container" :class="{ 'visible': isContainerVisible }">
    <div class="container-content">
    </div>
  </div>
</template>

<script>
import ThemeToggle from '@/components/ThemeToggle.vue';
import AppLogo from '@/components/AppLogo.vue';

export default {
  name: 'StickyContainer',
  components: {
    ThemeToggle,
    AppLogo
  },
  data() {
    return {
      isContainerVisible: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isContainerVisible = window.scrollY > 0;
    },
  },
};
</script>

<style scoped>
.sticky-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 999;
  background-color: transparent;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.sticky-container.visible {
  background-color: var(--container-color);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.container-content {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 0 70px; /* Đảm bảo không che logo và language button */
}

.header-indicator {
  width: 40%;
  height: 4px;
  background-color: var(--primary-color, #007bff); /* Màu mặc định nếu không có biến */
  border-radius: 2px;
}
</style>